import styled from 'styled-components';
import { gridGap, GridProps, JustifyContentProps } from 'styled-system';

export const ContentWrapper = styled.div<GridProps & JustifyContentProps>`
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  ${gridGap};
`;
export const ToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
